module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/01-0cfe7f8b86609ea1cf8dda37733fc684.jpg";